import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Locale = Record<string, string>;

export type LocaleByGroup = Record<string, Locale> & {
  days?: Locale;
  months?: Locale;
  games?: Locale;
  roulette_ui?: Locale;
  tableNames?: Locale;
};

export type LocaleState = {
  lang: string;
  loaded: boolean;
  isDisabled: boolean;
  locales: LocaleByGroup;
};

const initialState: LocaleState = {
  lang: 'en',
  loaded: false,
  locales: {},
  isDisabled: false,
};

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    set({ isDisabled, loaded, lang }, { payload }) {
      return { isDisabled, loaded, lang, ...payload };
    },
    toggle(state) {
      return { ...state, isDisabled: !state.isDisabled };
    },
    change(_state, { payload: _ }: PayloadAction<{ code: string }>) {},
  },
});

export const localeActions = localeSlice.actions;
export default localeSlice.reducer;
